export const fetchAds = async (name, is_mobile = false) => {

  if (typeof name !== 'string') {
    console.error('Invalid parameter: name parameter required');
    return null;
  }
  
  const sites = is_mobile ? 'mobile' : 'desktop';
  const baseUrl =
    process.env.NEXT_PUBLIC_NODE_ENV === 'production'
      ? 'https://detikads.femaledaily.com/static/ads/femaledaily/'
      : 'https://detikads.femaledaily.com/static/ads/femaledaily/staging_femaledaily/';

  try {
    const res = await fetch(`${baseUrl}${sites}/${name}.txt?${Math.random()}`);

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const text = await res.text();
    const cleanText = text.trim();

    return cleanText || null;
  } catch (error) {
    console.error('Error fetching adsDetikServer ===>', error);
    return null; // fallback null
  }
};
